import { ref, withParams } from 'vuelidate/lib/validators/common';

export default requireCheckedIf => withParams(
  { type: 'requireCheckedIf', eq: requireCheckedIf },
  function (value, parentVm) {
    const checkRefExists = ref(requireCheckedIf, this, parentVm) || false;
    const checkValExists = value || false;
    return !(checkRefExists && !checkValExists);
  },
);
